import { createContext } from 'react';
import type { BreadcrumbItem } from '@/shared/ui/primitives';

export interface BreadcrumbContextValue {
  items: BreadcrumbItem[];
  setItems: (items: BreadcrumbItem[]) => void;
}

/**
 * Holds the breadcrumb trail for the active workspace screen. Screens publish
 * their trail (see `useSetBreadcrumb`); the app shell's top bar reads it (see
 * `useBreadcrumbItems`) and renders it as the page's navigation heading — so
 * the trail lives where the page owns it but displays in the chrome.
 */
export const BreadcrumbContext = createContext<BreadcrumbContextValue | null>(null);
